import React,{useState, useEffect} from 'react';
import './PersonalityTest.css'
import axios from 'axios';
import {Slider,Spin} from 'antd'
import "antd/dist/antd.css"
import {HiDownload} from 'react-icons/hi'
import {FaArrowAltCircleRight} from 'react-icons/fa'
import jsPDF from 'jspdf'
import PersonalityReport from '../../Graph/PersonalityReport';
import { db } from '../../../../config/firebase'
import firebase from "firebase";
import {BsCheckCircleFill} from 'react-icons/bs'


const url = "https://totalappi.herokuapp.com/test1/questions";

const user = sessionStorage.getItem('user')

const PersonalityTest = () => {
    const [current,setCurrent] = useState(0)
    const [result,setResult] = useState(false)
    const [loading,setLoading] = useState(false)
    const [questions,setQuestions] = useState([]);
    const [answers,setAnswers] = useState([])


    useEffect(()=>{
        window.scrollTo(0,0)
    },[])

    const getQuestions = async () =>{
        axios.get(url)
        .then(res=>{
            let data = res.data
            setQuestions(data)
        })
        .catch(err=>{
            console.log(err)
        })
    }

    useEffect(()=>{
        getQuestions();
    },[])


    const moveNext = () => {
        setCurrent(current+1)
        console.log(value)
        setAnswers([...answers,value])

        if(current==questions.length-1){
            submit()
        }
        // if(current==4){
        //     submit()
        // }
    }

    const arr = {
        '0':'',
    }

    const [resultData,setResultData] = useState([])


    const submit = () => {
        let param = answers.join(" ")
        console.log(param)

        setLoading(true)

        axios({
            method: "GET",
            url: 'https://totalappi.herokuapp.com/test1/answers'+'/'+param,
        })
        .then(res => {
            // let careers = res.data["Careers to Avoid"]
            // let communication = res.data["Communication Style"]
            // let growth = res.data["Growth Potential"]
            // let perceive = res.data["How Others Perceive You"]
            // let personality = res.data["Personality Description"]
            // let strengthWeakness = res.data["Strengths and Weaknesses"]
            // let values = res.data["Values and Motivations"]
            // let work = res.data["Work Place Habits"]
            // setResultData([careers,communication,growth,perceive,personality,strengthWeakness,values,work])

            console.log(res)

            db.collection("contacts").doc(user).update({
                result: firebase.firestore.FieldValue.arrayUnion({'personality':res.data})
            }
            )
            .then(()=>{
                console.log('result added to document')
            })
            .catch(err=>{
                console.log(err)
            })


            setResult(true)
            setLoading(false)
            console.log(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }


    const [value,setValue] = useState(1)

    const changeValue = (value) => {
        console.log(value)
        setValue(value)
    }


    const downloadPdf = () => {
        var doc = new jsPDF()
        doc.setFont('Poppins')
        // doc.text(20,30,'priyanshu')
        doc.text(20,30,resultData[1])
        doc.save('a.pdf')
    }

    const marks = {
        1: "NOT apply",
        2: "RARELY applies",
        3: "SOME of the time",
        4: "MOSTLY applies",
        5: "ALWAYS applies"
    }

    return (
        <>
        {/* {
            result &&
            <div style={{position:'absolute',right:'10vw',top:'25vh'}}>
                <div className='download-button' onClick={downloadPdf}>
                    <HiDownload size={20}/>
                    <div>Download</div>
                </div>
            </div>
        } */}
        <div className='aptitude-container'>

            {
                loading &&
                <div style={{textAlign:'center'}}>
                    <Spin size='large'/>
                    <div>Submitting your test</div>
                </div>
            }
            {
                result ?
                // <h3 className='test-submitted'>
                //     <PersonalityReport resultData={resultData}/>
                // </h3>
                <div style={{textAlign:'center'}}>
                    <BsCheckCircleFill color='green' size='30px'/>
                    <div>Test submitted successfully</div>
                </div>
                :
                <>
                {
                    questions ?
                    <div>
                        <div className='question-no'>Question {current+1}.</div>
                        <h4 className='question'>{questions[current]}</h4>
                        <Slider marks={marks} onChange={changeValue} defaultValue={value} min={1} max={5} tooltipVisible style={{width:'100%',margin:'10vh auto'}} />

                        {
                            value===''?
                            <div className='next-container'>
                                {
                                    current===questions.length-1 ? <>Finish</> : <>Next</>
                                    // current===4 ? <>Finish</> : <>Next</>
                                }
                                <FaArrowAltCircleRight className='disabled'/>
                            </div>
                            :
                            <div onClick={moveNext} className='next-container'>
                                {
                                    current===questions.length-1 ? <>Finish</> : <>Next</>
                                    // current===4 ? <>Finish</> : <>Next</>
                                }
                                <FaArrowAltCircleRight className='active'/>
                            </div>
                        }
                    </div>
                    :
                    <h3 className='test-loader'>
                        <Spin size='large'/>
                        <div>loading test</div>
                    </h3>
                }
                </>
            }
        </div>
        </>
     );
}

export default PersonalityTest;